import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper/modules";
import Navbar from "./Navbar_old";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const MembershipPlans = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  //  Replace this with your actual number and QR image link
  const paymentNumber = "8602927816";
  const qrImage =
    ""; // example QR

  const handleChoosePlan = (plan) => {
    setSelectedPlan(plan);
    setShowPopup(true);
  };

  const copyNumber = () => {
    navigator.clipboard.writeText(paymentNumber);
    alert("Payment number copied!");
  };

  const plans = [
    {
      id: 1,
      title: "Gold Membership",
      price: "999 Rs / 6 month",
      gradient: "linear-gradient(145deg, #111, #7a4c00)",
      buttonColor: "#ffcc33",
      features: [
        "Unlimited Likes ❤️",
        "Unlimited Chat Access 💬",
        "Unlimited Calls 📞",
        "Top Profile",
        "Profile Boost 🚀",
        "Priority Support ⭐",
      ],
    },
    {
      id: 2,
      title: "Premium Membership",
      price: "499 Rs / 3 month",
      gradient: "linear-gradient(145deg, #111, #6e0e0e)",
      buttonColor: "#ff5c33",
      features: [
        "Unlimited Likes ❤️",
        "Unlimited Calls 📞",
        "Priority Support ⭐",
      ],
    },
    // {
    //   id: 3,
    //   title: "Platinum Membership",
    //   price: "Free",
    //   gradient: "linear-gradient(145deg, #111, #1a237e)",
    //   buttonColor: "#9ca8ff",
    //   features: [
    //     "Unlimited Likes ❤️",
    //     "NO Chat Access 💬",
    //     "NO Calls 📞",
    //     "NO Priority Support ⭐",
    //   ],
    // },
  ];

  return (
    <>
      <Navbar />

      <div
        style={{
          minHeight: "100vh",
          background: "radial-gradient(circle at top, #300000, #000)",
          color: "white",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Back Button */}
        <div className="container pt-4 d-flex justify-content-start">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline-light"
            style={{
              borderRadius: "25px",
              border: "2px solid #ffb400",
              color: "#ffb400",
              fontWeight: "600",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffb400";
              e.currentTarget.style.color = "#111";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffb400";
            }}
          >
            <i className="bi bi-arrow-left me-2"></i> Back
          </button>
        </div>

        {/* Heading */}
        <h2
          className="fw-bold text-center mt-4 mb-5"
          style={{
            textShadow: "0 0 20px rgba(255,255,255,0.25)",
            letterSpacing: "1px",
          }}
        >
          👌 Membership Plans😍
        </h2>

        {/* Swiper Slider */}
        <div className="container pb-5">
          <Swiper
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView="auto"
            coverflowEffect={{
              rotate: 30,
              stretch: 0,
              depth: 120,
              modifier: 1,
              slideShadows: false,
            }}
            pagination={{ clickable: true }}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            {plans.map((plan) => (
              <SwiperSlide
                key={plan.id}
                style={{
                  width: "320px",
                  height: "450px",
                  background: "transparent",
                }}
              >
                <div
                  className="card h-100 text-center d-flex flex-column justify-content-between p-4"
                  style={{
                    background: plan.gradient,
                    borderRadius: "20px",
                    border: "1px solid rgba(255,255,255,0.15)",
                
                    
                    backdropFilter: "blur(10px)",
                    color: "#fff",
                  }}
                >
                  <div>
                    <div
                      style={{
                        width: "70px",
                        height: "3px",
                        background: plan.buttonColor,
                        borderRadius: "2px",
                        margin: "0 auto 15px",
                      }}
                    ></div>

                    <h3 className="fw-bold mb-2">{plan.title}</h3>
                    <h5
                      className="fw-semibold mb-4"
                      style={{ color: "#ffe9c9" }}
                    >
                      {plan.price}
                    </h5>

                    <ul
                      className="list-unstyled text-start mx-auto"
                      style={{ maxWidth: "240px", lineHeight: "1.6" }}
                    >
                      {plan.features.map((f, i) => (
                        <li key={i}>✨ {f}</li>
                      ))}
                    </ul>
                  </div>

                  <button
                    className="btn fw-bold rounded-pill mt-3 px-4 py-2"
                    style={{
                      background: plan.buttonColor,
                      border: "none",
                      color: "#111",
                     
                    }}
                    onClick={() => handleChoosePlan(plan)}
                  >
                    Choose Plan
                  </button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Payment Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="p-4 text-center"
            style={{
              background: "linear-gradient(145deg,#1a1a1a,#000)",
              borderRadius: "20px",
              width: "340px",
              color: "#fff",
       
              
            }}
          >
            <h4 className="fw-bold mb-3">
              {selectedPlan?.title} Payment
            </h4>

            <img
              src={qrImage}
              alt="QR Code"
              style={{
                width: "180px",
                borderRadius: "10px",
                marginBottom: "15px",
              }}
            />

            <p style={{ marginBottom: "8px", color: "#ffcc33" }}>
              Pay using UPI / PhonePe / GPay
            </p>

            <div
              className="d-flex justify-content-center align-items-center mb-3"
              style={{
                background: "#222",
                padding: "10px 15px",
                borderRadius: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#ffcc33",
                }}
              >
                {paymentNumber}
              </span>
              <button
                className="btn btn-sm btn-warning ms-3"
                onClick={copyNumber}
              >
                Copy
              </button>
            </div>

            <button
              className="btn btn-outline-light rounded-pill px-4 mt-2"
              onClick={() => setShowPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default MembershipPlans;
